import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { PlanFeatureResponse } from '../../Interfaces/api/backoffice/feature.interface';
import {
  PlanComponentResponse,
  PlanDetailResponse,
  PlanMarketResponse,
  PlanPriceResponse,
} from '../../Interfaces/api/backoffice/plan.interface';

export class PlanDetail {
  id = '';
  code: string | null = null;
  name: string | null = null;
  version = 1;
  is_active = false;
  organization_id: string | null = null;
  market: PlanMarketResponse | null = null;
  subscriber_count = 0;
  created_at: string | null = null;
  updated_at: string | null = null;
  feature_keys: string[] = [];
  features: PlanFeatureResponse[] = [];
  prices: PlanPriceResponse[] = [];
  components: PlanComponentResponse[] = [];

  constructor(data: Partial<PlanDetailResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.code || this.id;
  }

  get marketLabel(): string {
    return this.market?.name || this.market?.code || VALUE_UNRESOLVED;
  }

  get currency(): string | null {
    return this.market?.currency ?? null;
  }

  get isTenantScoped(): boolean {
    return this.organization_id !== null;
  }
}
